import { render, staticRenderFns } from "./HorizontalMenu.vue?vue&type=template&id=37ec279e&scoped=true"
import script from "./HorizontalMenu.vue?vue&type=script&lang=js"
export * from "./HorizontalMenu.vue?vue&type=script&lang=js"
import style0 from "./HorizontalMenu.vue?vue&type=style&index=0&id=37ec279e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ec279e",
  null
  
)

export default component.exports